import { render } from "./PageNotFound.vue?vue&type=template&id=2e0556d3"
const script = {}
script.render = render

export default script